<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="extract"><span class="big"><strong>The Philosophy<br/>of Neo-Noir</strong></span><br/><br/><br/><br/></p>
<p class="extract"><span class="big2">Edited by Mark T. Conard</span><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/></p>
<p class="extract"><img alt="" src="OEBPS/images/tp.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780813172309_epub_tp_r1.vue?2b891c39